<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{ data.mode == leaveYearRulesMode.Add ? data.sysText.addLeaveYearRule_title : data.sysText.editLeaveYearRule_title }}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="close(false)" [attr.aria-label]="data.sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <app-date-field
      [group]="form"
      [control]="form.controls.effectiveDate"
      [icon]="'today'"
      [hint]="data.sysText.effectiveDateHint"
      [isHintHighlighted]="false"
      [label]="data.sysText.effectiveDate"
      [info]="data.sysText.effectiveDate_Info">
    </app-date-field>
    <app-select-field
      [control]="form.controls.bank"
      [label]="data.sysText.bank"
      [options]="bankOptions"
      [showBlankOption]="true"
      [icon]="'assignment_turned_in'"
      [shouldCapitalize]="false"
      [shouldTitlecaseLabel]="false"
      [info]="data.sysText.bank_Info">
    </app-select-field>
    <app-select-field
      [control]="form.controls.workingInState"
      [label]="data.sysText.workingInState"
      [options]="data.dialogOptions.stateOptions"
      [showBlankOption]="true"
      [icon]="'assignment_turned_in'"
      [shouldCapitalize]="false"
      [shouldTitlecaseLabel]="false"
      [info]="data.sysText.workingInState_Info">
    </app-select-field>
    <app-select-field
      [control]="form.controls.leaveYear"
      [label]="data.sysText.leaveYear"
      [options]="data.dialogOptions.leaveYearOptions"
      [showBlankOption]="true"
      [icon]="'assignment_turned_in'"
      [shouldCapitalize]="false"
      [shouldTitlecaseLabel]="false"
      [info]="data.sysText.leaveYear_Info">
    </app-select-field>
    <app-input-field
      [group]="form"
      [control]="form.controls.duration"
      [icon]="'date_range'"
      [label]="data.sysText.duration"
      [inputType]="'number'">
    </app-input-field>
    <app-select-field
      [control]="form.controls.durationType"
      [label]="data.sysText.durationType"
      [options]="durationTypeOptions"
      [icon]="'date_range'"
      [shouldCapitalize]="false"
      [shouldTitlecaseLabel]="false"
      [info]="data.sysText.durationType_Info">
    </app-select-field>
    <!-- "Start" field changes depending on the selected leave year -->
    @if (form.controls.leaveYear.value == leaveYear.FromFirstUsage) {
      <!-- Measured forward Start -->
      <app-select-field
        [control]="form.controls.measuredForwardStart"
        [label]="data.sysText.start"
        [options]="measuredForwardStartOptions"
        [showBlankOption]="true"
        [icon]="'today'"
        [shouldCapitalize]="false"
        [shouldTitlecaseLabel]="false"
        [info]="data.sysText.measuredForwardStart_Info">
      </app-select-field>
    }
    @else if (form.controls.leaveYear.value == leaveYear.Fixed) {
    <!-- Fixed Start -->
    <app-text-area
      [control]="form.controls.fixedStart"
      [label]="data.sysText.start"
      [icon]="'today'"
      [info]="data.sysText.fixedStart_Info">
    </app-text-area>
  }
  @else {
  <!-- "Dummy" disabled Start field -->
  <app-text-area
    [control]="form.controls.fixedStart"
    [label]="data.sysText.start"
    [isDisabled]="true"
    [icon]="'today'">
  </app-text-area>
}
<app-radio-button-group
  [control]="form.controls.restoreHours"
  [label]="data.sysText.restoreHours"
  [shouldCapitalizeLabel]="false"
  [icon]="'update'"
  [isStacked]="true"
  [isYesNo]="true"
  [info]="data.sysText.restoreHours_Info">
</app-radio-button-group>
@if (form.controls.restoreHours.value && selectedBank?.showRestoreConditions) {
  <div class="container restore-conditions">
    <div class="label">
      <p
        id="restore-conditions-label"
        class="body2">
        {{ data.sysText.restoreConditions_Label.replace("@[bank]", selectedBank.bankName) }}
      </p>
    </div>
    <mat-selection-list
      [formControl]="form.controls.restoreConditions"
      class="restore-list"
      aria-labelledby="restore-conditions-label">
      @for(restoreLeaveTypeOption of restoreLeaveTypeOptions; track restoreLeaveTypeOption.id){
        <mat-list-option class="restore-condition" [value]="restoreLeaveTypeOption.id">
          {{ restoreLeaveTypeOption.name }}
        </mat-list-option>
      }
    </mat-selection-list>
  </div>
}
<!-- Fmla Usage Rules Settings -->
<app-radio-button-group
  [control]="form.controls.followFmlaUsageRules"
  [label]="data.sysText.fmlaUsageRules"
  [shouldCapitalizeLabel]="false"
  [icon]="'assignment_turned_in'"
  [isStacked]="true"
  [isYesNo]="true"
  [info]="data.sysText.fmlaUsageRules_Info">
</app-radio-button-group>
@if (form.controls.followFmlaUsageRules.value) {
  <app-radio-button-group
    [control]="form.controls.isFullWeekClosureWorkdaysOnly"
    [label]="data.sysText.fullWeekClosure"
    [shouldCapitalizeLabel]="false"
    [isStacked]="true"
    [isYesNo]="true"
    [customYes]="data.sysText.everyWorkday"
    [customNo]="data.sysText.everyDay"
    [info]="data.sysText.fullWeekClosure_Info">
  </app-radio-button-group>
  <app-radio-button-group
    [control]="form.controls.isFullWeekAbsenceWorkdaysOnly"
    [label]="data.sysText.fullWeekAbsence"
    [shouldCapitalizeLabel]="false"
    [isStacked]="true"
    [isYesNo]="true"
    [customYes]="data.sysText.everyWorkday"
    [customNo]="data.sysText.everyDay"
    [info]="data.sysText.fullWeekAbsence_Info">
  </app-radio-button-group>
}
</form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!isSubmitting && this.form.errors?.msError) {
    <mat-error class="mse-form-error caption">{{ this.form.errors?.msError }}</mat-error>
  }
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="close(false)">
      {{data.sysText.cancel}}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && onSubmit()">
    {{data.sysText.save}}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>

